import nl2br from "../../../utils/nl2br"
import PhoneNumber, { isValidPhone } from "../../../components/PhoneNumber"
import isEmail from "validator/lib/isEmail"
import React, { useState } from "react"
import HubSpot from "../../../utils/HubSpot"
import MarketingConsentCheckbox from "../../../components/MarketingConsentCheckbox"
import submitToMailChimp from "../../../utils/submitToMailChimp"

export default function Form({ data }) {
  const { buttonLabel, sectionTitle, description, recipients, successMessage } =
    data
  const [formSent, setFormSent] = useState(false)
  const [progress, setProgress] = useState(false)

  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [company, setCompany] = useState("")
  const [message, setMessage] = useState("")
  const [marketingEmails, setMarketingEmails] = useState(true)

  const handleSubmit = async (e) => {
    e.preventDefault()

    setProgress(true)
    const formData = {
      email,
      toEmail: recipients,
      formData: [
        { label: "Name", value: name },
        { label: "Email", value: email },
        { label: "Phone number", value: phone },
        { label: "Company", value: company },
        { label: "Message", value: message },
      ],
    }

    const status = await HubSpot(null, null, formData)

    await submitToMailChimp(marketingEmails, name, email)

    if (status) {
      setFormSent(true)
    }
    setProgress(false)
  }

  return (
    <section className="event-form">
      <div className="container">
        <div className="form-wrapper">
          <form action="#" onSubmit={handleSubmit} className={"center-message"}>
            <div className="row justify-content-center">
              <div className="col-sm-12 col-md-10 col-lg-10 col-xl-6 d-flex justify-content-center">
                <div
                  className={`form-message start-50 top-50 translate-middle ${
                    formSent ? "sent" : ""
                  }`}
                >
                  <p>
                    <strong>
                      {successMessage ? nl2br(successMessage) : "Success"}
                    </strong>
                  </p>
                </div>
              </div>
            </div>

            <div className={`form-body ${formSent ? "sent" : ""}`}>
              <div className="row justify-content-center">
                <div className="col-10 col-xl-9 text-center">
                  <h2>{sectionTitle}</h2>
                  {description && <p className={"mb-5"}>{description}</p>}
                </div>
                <div className="col-12" />
                <div className="col-sm-12 col-md-10 col-lg-10 col-xl-6">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder={"Full name *"}
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder={"Work Email *"}
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder={"Company *"}
                          value={company}
                          onChange={(e) => setCompany(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <PhoneNumber
                          setPhone={setPhone}
                          value={phone}
                          placeholder={"Phone Number *"}
                        />
                      </div>
                    </div>

                    <div className="col-sm-12">
                      <div className="form-group">
                        <textarea
                          name=""
                          id=""
                          rows="5"
                          className={"form-control"}
                          placeholder={"Additional comments (Optional)"}
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-sm-12" style={{ marginTop: "-12px" }}>
                      <MarketingConsentCheckbox
                        checked={marketingEmails}
                        setChecked={setMarketingEmails}
                      />
                    </div>

                    <div className="col-sm-12">
                      <div className="form-group mb-0">
                        <button
                          className="btn btn-primary"
                          disabled={
                            progress ||
                            !name ||
                            !email ||
                            !isEmail(email) ||
                            !phone ||
                            !isValidPhone(phone)
                          }
                        >
                          {buttonLabel}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  )
}
